export const AddProgramTabs = [
  {
    displayValue: "basic_details",
  },
  {
    displayValue: "tags_highlights",
  },
  {
    displayValue: "courses",
  },
  {
    displayValue: "certification",
  },
  {
    displayValue: "preview",
  },
];
export const ViewProgramDetailTabs = [
  {
    displayValue: "detail_view_description",
  },
  {
    displayValue: "detail_view_learn_section",
  },
  {
    displayValue: "detail_view_courses",
  },
  // {
  //   displayValue: "detail_view_enrollments",
  // },
];
export const ProgramTableHeader = [
  { key: "slug", displayValue: "code", sort: true },
  { key: "title", displayValue: "title", sort: true },
  {
    key: "is_free",
    displayValue: "is_free",
    sort: true,
    callbackFunction: "displayAutoCharged",
  },
  { key: "enroll_credits", displayValue: "enroll_credits", sort: true },
  { key: "reward_credits", displayValue: "reward_credits", sort: true },
  {
    key: "language",
    displayValue: "language",
    sort: true,
    callbackFunction: "getLanguageTitle",
  },
  {
    key: "tags",
    displayValue: "tags",
    sort: true,
    callbackFunction: "displayTags",
  },
  {
    key: "status",
    displayValue: "status",
    sort: true,
    callbackFunction: "displayUnitStatus",
  },
];
export const ProgramGridHeader = {
  header: [
    { callbackFunction: "displayTitleWithSlug" },
    { callbackFunction: "displayIsFreeField" },
  ],
  body: [
    {
      key: "enroll_credits",
      displayValue: "enroll_credits",
    },
    {
      key: "reward_credits",
      displayValue: "reward_credits",
    },
    {
      key: "language",
      displayValue: "language",
      callbackFunction: "getLanguageTitle",
    },
    {
      key: "tags",
      displayValue: "tags",
      callbackFunction: "displayTags",
    },
    {
      key: "status",
      displayValue: "status",
      callbackFunction: "displayUnitStatus",
    },
  ],
};
export const ModalButtons = {
  exportSuccess: {
    text: "export_success",
    buttons: [
      {
        text: "ok",
        variant: "blue-1",
        onClick: "closeModal",
        loading: false,
        disabled: false,
      },
    ],
  },
  exportError: {
    text: "",
    buttons: [
      {
        text: "ok",
        variant: "red-1",
        onClick: "closeModal",
        loading: false,
        disabled: false,
      },
    ],
  },
  coursesConflict: {
    text: "courses_conflict",
    buttons: [
      {
        text: "ok",
        variant: "red-1",
        onClick: "coursesErrorModal",
        loading: false,
        disabled: false,
      },
    ],
  },
  confirmDelete: {
    text: "delete_record",
    buttons: [
      {
        text: "deactivate",
        variant: "red-1",
        onClick: "deactivateProgram",
      },
      {
        text: "cancel",
        variant: "white-1",
        onClick: "closeModal",
        loading: false,
        disabled: false,
      },
    ],
  },
  confirmActive: {
    text: "active_record",
    buttons: [
      {
        text: "activate",
        variant: "blue-1",
        onClick: "deactivateProgram",
      },
      {
        text: "cancel",
        variant: "white-1",
        onClick: "closeModal",
        loading: false,
        disabled: false,
      },
    ],
  },
  recordDelete: {
    text: "record_deleted",
    buttons: [
      {
        text: "ok",
        variant: "blue-1",
        onClick: "closeModal",
        loading: false,
        disabled: false,
      },
    ],
  },
  recordUpdate: {
    text: "record_update",
    buttons: [
      {
        text: "ok",
        variant: "blue-1",
        onClick: "closeModal",
        loading: false,
        disabled: false,
      },
    ],
  },
  recordCreated: {
    text: "record_created",
    buttons: [
      {
        text: "ok",
        variant: "blue-1",
        onClick: "closeModal",
        loading: false,
        disabled: false,
      },
    ],
  },
  recordActivated: {
    text: "record_activate",
    buttons: [
      {
        text: "ok",
        variant: "blue-1",
        onClick: "closeModal",
        loading: false,
        disabled: false,
      },
    ],
  },
  deactivateActionError: {
    text: "action_on_deactivated_error",
    buttons: [
      {
        text: "ok",
        variant: "blue-1",
        onClick: "closeModal",
        loading: false,
        disabled: false,
      },
    ],
  },
  listing403: {
    text: "403_error_msg",
    buttons: [
      {
        text: "ok",
        variant: "red-1",
        onClick: "closeModal",
        loading: false,
        disabled: false,
      },
    ],
  },
};
export const ExportProgramHeaders = [
  { key: "program_id", label: "Id" },
  { key: "title", label: "Title" },
  { key: "category_id", label: "Category" },
  { key: "subscription", label: "Subscription" },
  { key: "language_id", label: "Language" },
  { key: "enroll_credits", label: "Enrolled Credits" },
  { key: "reward_credits", label: "Reward Credits" },
  { key: "is_free", label: "Is Free" },
  { key: "author_name", label: "Author Name" },
  { key: "payment_type", label: "Payment Type" },
  { key: "completion_duration", label: "Completion Duration" },
  { key: "duration_type", label: "Duration Type" },
  { key: "description", label: "Detail" },
  { key: "short_description", label: "Short Description" },
  { key: "tags", label: "Tags List" },
  {
    key: "learning_points",
    label: "Learning Points",
  },
  {
    key: "program_pre_requisite_courses",
    label: "Pre Requisite Courses",
  },
  {
    key: "program_compulsory_courses",
    label: "Compulsory Courses",
  },
  {
    key: "program_elective_courses",
    label: "Elective Courses",
  },
  { key: "completed_percentage", label: "Completion Percentage" },
  { key: "quiz_percentage", label: "Quiz Percentage" },
  { key: "validity_period", label: "Validity Period" },
  { key: "validity_type", label: "Validity Type" },
  { key: "certificate_description", label: "Certificate Description" },
];
export const ImportProgramTableHeaders = [
  { key: "no", displayValue: "#" },
  { key: "program_id", displayValue: "id" },
  { key: "title", displayValue: "title" },
  { key: "category_id", displayValue: "category" },
  { key: "subscription", displayValue: "subscription" },
  { key: "language_id", displayValue: "language" },
  { key: "enroll_credits", displayValue: "enroll_credits" },
  { key: "reward_credits", displayValue: "reward_credits" },
  { key: "is_free", displayValue: "is_free" },
  { key: "author_name", displayValue: "author_name" },
  { key: "payment_type", displayValue: "payment_type" },
  { key: "completion_duration", displayValue: "completion_duration" },
  { key: "duration_type", displayValue: "duration_type" },
  { key: "description", displayValue: "description" },
  { key: "short_description", displayValue: "short_description" },
  { key: "tags", displayValue: "tags_list" },
  {
    key: "learning_points",
    displayValue: "learning_points",
  },
  {
    key: "program_pre_requisite_courses",
    displayValue: "pre_req_courses",
  },
  {
    key: "program_compulsory_courses",
    displayValue: "compulsory_courses",
  },
  {
    key: "program_elective_courses",
    displayValue: "elective_courses",
  },
  { key: "completed_percentage", displayValue: "completion_percentage" },
  { key: "quiz_percentage", displayValue: "quiz_percentage" },
  { key: "validity_period", displayValue: "validity_period" },
  { key: "validity_type", displayValue: "validity_type" },
  { key: "certificate_description", displayValue: "certificate_description" },
];